// extracted by mini-css-extract-plugin
export default {"framework-selector":"T_cB d-flex","framework-selector__icon":"T_cC","framework-selector__option":"T_cD p-2 flex-grow-1 ml-2","framework-selector__option--selected":"T_cF"};